import React from 'react';
import { useModel } from '@umijs/max';

export interface IVideoData {
  type: string;
  isLive: boolean;
  url: string;
}

const AuthWrap = ({
  // permission = '',
  newPermission = '',
  children,
}: {
  permission?: string;
  newPermission?: string;
  children: React.ReactNode;
}) => {
  const { permissions } = useModel('user');
  const hasPermission = !newPermission || !!permissions[newPermission as keyof typeof permissions];

  if (!hasPermission) return null;

  return children;
};
export default AuthWrap;
